import { useRequiredContext } from "@redotech/react-util/context";
import RefreshIcon from "@redotech/redo-icons/refresh-cw-01.svg";
import RefreshFilledIcon from "@redotech/redo-icons/refresh-cw-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { replenishmentReportHref } from "@redotech/redo-merchant-fulfillment-app/wms/replenishment-report/replenishment-report-href";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo, useContext } from "react";
import { OrderManagementSuiteStatusesContext } from "../../../../redo-suite/order-management-cloud";

export const ReplenishmentReportItem = memo(function ReplenishmentReportItem() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { wmsEnabled } = useContext(OrderManagementSuiteStatusesContext);

  if (!wmsEnabled) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: replenishmentReportHref(routes.warehouseHref, null),
      }}
      FilledIcon={RefreshFilledIcon}
      friendlyName="Replenishment report"
      id="replenishment-report"
      UnfilledIcon={RefreshIcon}
    />
  );
});
